module.exports = __webpack_public_path__ + "static/media/monj2.90882a5e.png";